var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1108 6.13845C29.1596 5.96525 29.1613 5.78217 29.1159 5.60807C29.0704 5.43396 28.9794 5.27511 28.8522 5.14787C28.7249 5.02063 28.5661 4.9296 28.392 4.88415C28.2179 4.8387 28.0348 4.84047 27.8616 4.88927L3.56159 12.2577C3.3632 12.3137 3.18663 12.4289 3.05547 12.588C2.92432 12.747 2.84483 12.9423 2.82763 13.1477C2.81043 13.3531 2.85634 13.5589 2.95923 13.7375C3.06211 13.9162 3.21707 14.0591 3.40339 14.1473L14.4687 19.5313L19.8527 30.5954C19.9409 30.7817 20.0839 30.9367 20.2625 31.0395C20.4411 31.1424 20.6469 31.1883 20.8523 31.1711C21.0578 31.1539 21.253 31.0745 21.4121 30.9433C21.5711 30.8121 21.6863 30.6356 21.7423 30.4372L29.1108 6.13845Z",
    fill: "#00E24B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4688 19.5313L21.05 12.9501",
    stroke: "#0D0A0A",
    strokeWidth: 2.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1108 6.13845C29.1596 5.96525 29.1613 5.78217 29.1159 5.60807C29.0704 5.43396 28.9794 5.27511 28.8522 5.14787C28.7249 5.02063 28.5661 4.9296 28.392 4.88415C28.2179 4.8387 28.0348 4.84047 27.8616 4.88927L3.56159 12.2577C3.3632 12.3137 3.18663 12.4289 3.05547 12.588C2.92432 12.747 2.84483 12.9423 2.82763 13.1477C2.81043 13.3531 2.85634 13.5589 2.95923 13.7375C3.06211 13.9162 3.21707 14.0591 3.40339 14.1473L14.4687 19.5313L19.8527 30.5954C19.9409 30.7817 20.0839 30.9367 20.2625 31.0395C20.4411 31.1424 20.6469 31.1883 20.8523 31.1711C21.0578 31.1539 21.253 31.0745 21.4121 30.9433C21.5711 30.8121 21.6863 30.6356 21.7423 30.4372L29.1108 6.13845Z",
    stroke: "#0D0A0A",
    strokeWidth: 2.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.ab105a2b9c660886346cdb091589ac5b.svg";
export { ForwardRef as ReactComponent };